import React, { useEffect } from 'react';
import { ArrowLeft } from 'lucide-react';
import gsap from 'gsap';
import './LegalShared.css';

const CookiesPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    const tl = gsap.timeline();
    tl.fromTo('.legal-header-main', { y: 30, opacity: 0 }, { y: 0, opacity: 1, duration: 0.8, ease: 'power2.out' })
      .fromTo('.legal-brief-box', { x: -30, opacity: 0 }, { x: 0, opacity: 1, duration: 0.8, ease: 'power2.out' }, "-=0.4")
      .fromTo('.legal-section-card', { y: 20, opacity: 0 }, { y: 0, opacity: 1, duration: 0.6, stagger: 0.15, ease: 'power2.out' }, "-=0.4");
  }, []);

  return (
    <div className="legal-page-shared">
      <div className="legal-container">
        <div className="legal-top-nav">
          <a href="/" className="back-link-gold">
            <ArrowLeft size={16} /> BACK TO HOME
          </a>
        </div>

        <header className="legal-header-main">
          <h1 className="legal-title-gold">Cookies Policy</h1>
          <p className="legal-subtitle-white">Enhancing your digital aura</p>
        </header>

        <div className="legal-brief-box">
          <span className="brief-label">THE ESSENCE</span>
          <p className="brief-text-gold">
            "Cookies are the subtle notes that help us remember your unique preferences, ensuring your digital experience is as smooth and personalized as our finest silk."
          </p>
        </div>

        <div className="legal-content-grid">
          <section className="legal-section-card">
            <span className="section-tag">01. WHAT ARE COOKIES?</span>
            <h2 className="section-heading-gold">Digital Signatures</h2>
            <p className="section-text-white">
              Cookies are small data fragments stored on your device. They act as a memory for our Maison, helping us recognize you when you return and allowing us to provide a seamless, premium shopping experience.
            </p>
          </section>

          <section className="legal-section-card">
            <span className="section-tag">02. PERFORMANCE</span>
            <h2 className="section-heading-gold">Enhancing the Experience</h2>
            <p className="section-text-white">
              We use performance cookies to understand how you interact with our site. This data is anonymized and used exclusively to improve the speed, elegance, and functionality of our digital boutique.
            </p>
          </section>

          <section className="legal-section-card">
            <span className="section-tag">03. PERSONALIZATION</span>
            <h2 className="section-heading-gold">Tailored to You</h2>
            <p className="section-text-white">
              Preference cookies allow us to remember your choices—such as your preferred language or region—so that your journey through the world of Escentrum is always tailored to your specific desires.
            </p>
          </section>

          <section className="legal-section-card">
            <span className="section-tag">04. CONTROL</span>
            <h2 className="section-heading-gold">Managing Your Aura</h2>
            <p className="section-text-white">
              You have full control over your cookie settings. You can choose to block or delete cookies through your browser settings, though this may slightly alter the fluidity of your experience on our site.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default CookiesPage;
